import React, { useCallback } from 'react'

import {
  Notice,
  Button,
  Icon,
  InfoFilled,
  ClockDefault,
  CircleCheck,
  Refresh,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  oneOf, bool, func,
} from 'prop-types'

import I18n from 'Pods/Shared/I18n'

import { NOOP } from 'Utils/stableDefaults'

import { IMAGE_RESTORE_STATUS } from './constants'

const { IDLE, PENDING, FINISHED } = IMAGE_RESTORE_STATUS
const KEY_PREFIX = 'profile.my_models.image_restore'

const leadIcon = (svgComponent, color, withHover = false) => (
  <Icon
    svgComponent={svgComponent}
    className="cgt-notice__icon"
    spaceless
    notSpaced
    color={color}
    withHover={withHover}
  />
)

function RestoreBanner({
  status, isTriggering = false, onRestore = NOOP, onClose,
}) {
  const translate = useCallback(
    (key) => I18n.t(`${KEY_PREFIX}.${key}`, { ns: 'rails' }),
    []
  )

  const copy = (state) => (
    <div className="image-restore__copy">
      <span className="image-restore__title cgt-body-md-semibold">{translate(`title_${state}`)}</span>
      <span className="image-restore__text cgt-body-base">{translate(`body_${state}`)}</span>
    </div>
  )

  if (status === FINISHED) {
    return (
      <Notice
        type="positive"
        useSSRIcon
        ssrIcon={leadIcon(CircleCheck, 'positive')}
        className="cgt-mb-10 image-restore"
        onClose={onClose}
      >
        <div className="image-restore__body">{copy('finished')}</div>
      </Notice>
    )
  }

  if (status === PENDING) {
    return (
      <Notice
        type="info"
        useSSRIcon
        ssrIcon={leadIcon(ClockDefault, 'primary')}
        className="cgt-mb-10 image-restore"
        onClose={onClose}
      >
        <div className="image-restore__body">
          {copy('pending')}
          <div className="image-restore__action">
            <Button
              type="secondary"
              actionType="button"
              size="small"
              disabled
              icon={<Icon svgComponent={ClockDefault} size="small" notSpaced />}
            >
              {translate('button_requested')}
            </Button>
            <span className="image-restore__helper cgt-caption">{translate('helper_within_3_days')}</span>
          </div>
        </div>
      </Notice>
    )
  }

  return (
    <Notice
      type="info"
      useSSRIcon
      ssrIcon={leadIcon(InfoFilled, 'darker', true)}
      className="cgt-mb-10 image-restore"
      onClose={onClose}
    >
      <div className="image-restore__body">
        <span className="image-restore__lead cgt-body-base">{translate('body_default')}</span>
        <div className="image-restore__action">
          <Button
            type="primary"
            actionType="button"
            size="small"
            disabled={isTriggering}
            onClick={onRestore}
            icon={<Icon svgComponent={Refresh} size="small" notSpaced />}
          >
            {translate('button_restore')}
          </Button>
        </div>
      </div>
    </Notice>
  )
}

RestoreBanner.propTypes = {
  status: oneOf([IDLE, PENDING, FINISHED]).isRequired,
  isTriggering: bool,
  onRestore: func,
  onClose: func.isRequired,
}

export default RestoreBanner
